export const Breadcrumb = {
  baseStyle: {
    link: {
      color: 'blueGray.700',
    },
  },
  variants: {
    test: {
      link: {
        '&:not(.active)': {
          color: 'gray.450',
        },
      },
      separator: {
        color: 'gray.450',
      },
    },
  },
}
